import React, { useCallback } from 'react';
import { Flex, List, Text } from '@leverege/ui-elements';
import { useWizard } from '@leverege/ui-wizard';
import I18N from '@leverege/i18n';
import S from './SelectionRenderer.css';
const {
  t
} = I18N.ns('pairing.imagine.PairingSelectionRenderer');
function TagPairingSelectionRenderer(props) {
  const {
    item,
    name,
    onChange: pOnChange,
    eventData
  } = props;
  const {
    context,
    setActiveStep
  } = useWizard();
  const {
    parentAttribute,
    relationship
  } = context;
  const assetId = parentAttribute.get(item);
  const onClick = useCallback(({
    item
  }) => {
    const evt = {
      data: eventData,
      value: item
    };
    if (assetId) {
      pOnChange(evt);
      setActiveStep('tagPaired');
    } else {
      pOnChange(evt);
    }
  }, [pOnChange, assetId, setActiveStep, eventData]);
  return /*#__PURE__*/React.createElement(List.Item, {
    className: S.listItem,
    key: item.id,
    item: item.id,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Flex, {
    variant: "rowM",
    align: "baseline"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-fw fa-search"
  }), /*#__PURE__*/React.createElement(Flex, {
    variant: "colS"
  }, /*#__PURE__*/React.createElement(Text, null, name), assetId && /*#__PURE__*/React.createElement(Text, {
    variant: "pairingErrorSubtitle"
  }, t('alreadyPaired', {
    blueprintName: relationship.blueprint.name
  })))));
}
const base = {
  sort: 'zzz',
  component: TagPairingSelectionRenderer
};
export default {
  create(opts) {
    return {
      ...base,
      id: `pairing.imagine.${opts.matches.objectType}.${opts.matches.actionType}.TagPairingSelectionRenderer`,
      matches: opts.matches
    };
  }
};